import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { AppLayout } from '@/components/layouts/app-layout';
import { GuestLayout } from '@/components/layouts/guest-layout';
import { AuthProvider, ProtectedRoute } from '@/contexts/auth';
import { SignInPage } from '@/pages/auth/signin';
import { PickingPage } from '@/pages/picking';
import { PickingDetailPage } from '@/pages/picking/[id]';
import { ReceivingPage } from '@/pages/receiving';
import { ReceivingDetailPage } from '@/pages/receiving/[id]';
import { TopPage } from '@/pages/top';

const AuthenticatedLayout = () => {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    </AuthProvider>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<GuestLayout />}>
          <Route path="/signin" element={<SignInPage />} />
        </Route>
        <Route element={<AuthenticatedLayout />}>
          <Route path="/" element={<TopPage />} />
          <Route path="/picking" element={<PickingPage />} />
          <Route path="/picking/:id" element={<PickingDetailPage />} />
          <Route path="/receiving" element={<ReceivingPage />} />
          <Route path="/receiving/:id" element={<ReceivingDetailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
};

export default App;
